<template>

  <AbortStateTemplate
      :headline="headline"
      :message="abortMessage"
      :teaserCards="teaserCardsData"
  />
</template>

<script>
import teaserCardsData from "@/data/teaserDataBuildingType";
import AbortStateTemplate from "@/components/abortStates/AbortStateTemplate.vue";

export default {
  name: 'StateAbortBuildingType',
  components: {
    AbortStateTemplate,
  },
  data() {
    return {
      headline:
      "Vielen Dank für Ihre Interesse. Aktuell können wir leider kein passendes Angebot für ein Mehrfamilienhaus erstellen. ",

      abortMessage:
          "Unser Angebot für ein PV-Komplettpaket ist derzeit nur auf Eigentümer:innen ausgerichtet, die eine PV-Anlage auf ihrem Ein- oder Zweifamilienhaus oder geeignetem Reihenhaus installieren möchten. Wir bauen unser Angebot aber zukünftig weiter aus.",
      teaserCardsData
    };
  },
}
</script>

<style scoped>

</style>
